import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  // ReusableOnboardingLink,
} from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import {
  // ToggleButtonReuseTwo,
  ToggleButtonWithYesNo,
} from "../../../AllButton/ToggleButtonReuse";

import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../../store/actions/authAction";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
// import isEmpty from "../../../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import store from "../../../../../../../store/store";
import { UPDATE_SUBSCRIPTION_TYPE } from "../../../../../../../store/types";
// import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
// import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Col, Row } from "react-bootstrap";
import LeftSideNavigation from "../../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../../../../../vendorDashboardComponents/navigationSection/RightSideNavigation";
import AddBankDetails from "./AddBankDetails";
// import MassCompletion from "../MassCompletion";

export const OfflineExperienceManagement = (props) => {
  const [disabled, setDisable] = useState(
    props?.history?.location?.state?.access === "View"
      ? true
      : false
  );
  const history = useHistory();
  const [state, setState] = useState({
    bank_account: false,
    casualDiningSpecialExperience: false,
    casualDiningCuratedExperience: false,
    activeAccount: [],
  });

  const onClickCasualSpecialExperience = (e) => {
    if (state.casualDiningSpecialExperience === true && !e) {
      setState({
        ...state,
        casualDiningSpecialExperience: !state.casualDiningSpecialExperience,
      });
    } else {
      history.push({
        pathname: `${history.location.pathname.includes("multi-service")
            ? "/multi-service"
            : "/casual-fine-dining"
          }/experience-management/offline/special`,
        state: { access: e },
      });
    }
  };

  const onClickCasualCuratedExperience = (e) => {
    if (state.casualDiningCuratedExperience === true && !e) {
      setState({
        ...state,
        casualDiningCuratedExperience: !state.casualDiningCuratedExperience,
      });
    } else {
      history.push({
        pathname: `${history.location.pathname.includes("multi-service")
            ? "/multi-service"
            : "/casual-fine-dining"
          }/experience-management/offline/curated`,
        state: { access: e },
      });
    }
  };

  const onCasualOfflineExperienceSubmitClick = () => {
    let values = {
      value:
        state.casualDiningSpecialExperience === false &&
          state.casualDiningCuratedExperience === false
          ? false
          : true,
      special: {
        value: state.casualDiningSpecialExperience,
      },
      curated: {
        value: state.casualDiningCuratedExperience,
      },
    };
    const token = props?.auth?.user?.accessToken;
    const subscriptionId = props?.subscription?._id;
    let formData = props?.allSubscriptionsData;
    formData = {
      ...formData,
      experience_management: {
        ...formData?.experience_management,
        offline_experience: {
          ...formData?.experience_management?.offline_experience,
          special: {
            ...formData?.experience_management?.offline_experience?.special,
          },
          curated: {
            ...formData?.experience_management?.offline_experience?.curated,
          },
        },
        massCompletion: {
          ...formData?.experience_management?.massCompletion,
        },
      },
    };

    formData.experience_management.offline_experience.value = values?.value;
    formData.experience_management.offline_experience.special.value =
      values?.special.value;
    formData.experience_management.offline_experience.curated.value =
      values?.curated.value;

    formData.experience_management.offline_experience.bank_account = {
      value: values?.bank_account,
      ...formData.experience_management.offline_experience.bank_account,
    };

    let sendData = {
      ...props.subscription,
    };
    if (props.subscription?.multi_service_business) {
      sendData.multi_service_business_status = formData;
    } else if (props.subscription?.fast_food_dining) {
      sendData.fast_food_dining_status = formData;
    } else {
      sendData.casual_dining_status = formData;
    }
    props.update_new_subscription_for_vendor(
      subscriptionId,
      sendData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Changes submitted successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    history.goBack();
  };

  useEffect(() => {
    setState({
      ...state,
      bank_account:
        props?.subscriptionData?.offline_experience?.bank_account?.value,
      activeAccount:
        props?.subscriptionData?.offline_experience?.bank_account
          ?.addedAccounts,
      casualDiningSpecialExperience:
        props?.subscriptionData &&
          props?.subscriptionData?.offline_experience?.special &&
          props?.subscriptionData?.offline_experience?.special?.value !==
          undefined
          ? props?.subscriptionData &&
          props?.subscriptionData?.offline_experience?.special &&
          props?.subscriptionData?.offline_experience?.special?.value
          : false,
      casualDiningCuratedExperience:
        props?.subscriptionData &&
          props?.subscriptionData?.offline_experience?.curated &&
          props?.subscriptionData?.offline_experience?.curated?.value !==
          undefined
          ? props?.subscriptionData &&
          props?.subscriptionData?.offline_experience?.curated &&
          props?.subscriptionData?.offline_experience?.curated?.value
          : false,
    });
  }, [props?.subscriptionData]);

  const backButtonHandler = (e) => {
    e.preventDefault();
    if (bankScreen) {
      setBankScreen(!bankScreen);
    } else {
      const formData = {
        casualDiningManagement: true,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: false,
      };
      store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
      history.goBack();
    }
  };

  const [bankScreen, setBankScreen] = useState(false);
  const [bankDisabled, setBankDisabled] = useState(false);
  const enableBooking = (e) => {
    if (state.bank_account === true && !e) {
      setState({ ...state, bank_account: !state.bank_account });
    } else {
      let values = {
        value:
          state.casualDiningSpecialExperience === false &&
            state.casualDiningCuratedExperience === false
            ? false
            : true,
        special: {
          value: state.casualDiningSpecialExperience,
        },
        curated: {
          value: state.casualDiningCuratedExperience,
        },
      };
      const token = props?.auth?.user?.accessToken;
      const subscriptionId = props?.subscription && props?.subscription?._id;
      let formData = props?.allSubscriptionsData;
      formData = {
        ...formData,
        experience_management: {
          ...formData?.experience_management,
          offline_experience: {
            ...formData?.experience_management?.offline_experience,
            special: {
              ...formData?.experience_management?.offline_experience?.special,
            },
            curated: {
              ...formData?.experience_management?.offline_experience?.curated,
            },
          },
          massCompletion: {
            ...formData?.experience_management?.massCompletion,
          },
        },
      };
      formData.experience_management.offline_experience.value = values?.value;
      formData.experience_management.offline_experience.special.value =
        values?.special.value;
      formData.experience_management.offline_experience.curated.value =
        values?.curated.value;

      // formData.experience_management.offline_experience.bank_account = {
      //   value: values?.bank_account,
      //   ...formData.experience_management.offline_experience.bank_account,
      // };
      // formData.experience_management.offline_experience.bank_account = {
      //   value: state?.bank_account,
      //   addedAccounts: state?.activeAccount,
      // };

      let sendData = {
        ...props.subscription,
      };
      if (props.subscription?.multi_service_business) {
        sendData.multi_service_business_status = formData;
      } else if (props.subscription?.fast_food_dining) {
        sendData.fast_food_dining_status = formData;
      } else {
        sendData.casual_dining_status = formData;
      }
      props.update_new_subscription_for_vendor(
        subscriptionId,
        sendData,
        token,
        () => bookingSuccess(e)
      );
    }
  };
  const bookingSuccess = (e) => {
    setBankScreen(true);
    if (e === "View") setBankDisabled(true);
    else setBankDisabled(false);
  };

  const onClickCopyScan = () => {
    const token = props?.auth?.user?.accessToken;
    const subscriptionId = props?.subscription?._id;
    let existingData = [
      ...props?.subscriptionData?.offline_experience?.bank_account
        ?.addedAccounts,
      ...props?.scanAndPay?.addedAccounts,
    ];

    let formData = props.allSubscriptionsData;
    formData.experience_management.offline_experience.bank_account = {
      ...formData.experience_management.offline_experience.bank_account,
      value: true,
      addedAccounts: existingData,
    };
    let sendData = {
      ...props.subscription,
    };
    if (props.subscription?.multi_service_business) {
      sendData.multi_service_business_status = formData;
    } else if (props.subscription?.fast_food_dining) {
      sendData.fast_food_dining_status = formData;
    } else {
      sendData.casual_dining_status = formData;
    }
    props.update_new_subscription_for_vendor(
      subscriptionId,
      sendData,
      token,
      onSuccessCopyScan
    );
  };

  const onSuccessCopyScan = () => {
    Alert.success(
      `<h4>Bank Details Added Successfully, Check your bank account we have credited 1 ₹ in your bank account</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
    // formik.resetForm();
  };

  if (props?.auth?.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        {props?.auth?.user?.VendorUser?.have_vendor_submitted_details ? (
          <div className="container-fluid">
            <Row>
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
              <div className="right-side-panel">
                <RightSideNavigation
                  leftText="vendorReview"
                  actionPerform="button"
                  backButtonLink={() =>
                    bankScreen ? setBankScreen(false) : history.goBack()
                  }
                  displayText="Back"
                />
                <Col
                  lg={12}
                  className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 new-subscription-onboarding-component"
                >
                  {bankScreen ? (
                    <>
                      <AddBankDetails
                        screenSet={(r) => setBankScreen(r)}
                        onClickCopyScan={onClickCopyScan}
                        disabled={bankDisabled}
                        dashboard={
                          props?.auth?.user?.VendorUser
                            ?.have_vendor_submitted_details
                        }
                      />
                    </>
                  ) : (
                    <div className="inside-subscription-event-section">
                      <InnerComponent
                        state={state}
                        enableBooking={enableBooking}
                        onClickCopyScan={onClickCopyScan}
                        onClickCasualSpecialExperience={
                          onClickCasualSpecialExperience
                        }
                        onClickCasualCuratedExperience={
                          onClickCasualCuratedExperience
                        }
                        disabled={disabled}
                        backButtonHandler={backButtonHandler}
                        onCasualOfflineExperienceSubmitClick={
                          onCasualOfflineExperienceSubmitClick
                        }
                      />
                    </div>
                  )}
                </Col>
              </div>
            </Row>
          </div>
        ) : (
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
              >
                <Media query="(min-width: 992px)">
                  <div className="col-12">
                    <BackLogoIconButton
                      displayBackText={true}
                      displayArrow={true}
                      workWithLinkORClick={true}
                      notDisplaProgressBar={true}
                      backButtonClicked={(e) => backButtonHandler(e)}
                    />
                  </div>
                </Media>

                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    link={false}
                    onClick={(e) => backButtonHandler(e)}
                  />
                </Media>
                {bankScreen ? (
                  <>
                    <AddBankDetails
                      screenSet={(r) => setBankScreen(r)}
                      disabled={bankDisabled}
                      onClickCopyScan={onClickCopyScan}
                    />
                  </>
                ) : (
                  <div className="onboarding_process_screen-button-map inside-subscription-event-section">
                    <InnerComponent
                      state={state}
                      enableBooking={enableBooking}
                      onClickCopyScan={onClickCopyScan}
                      onClickCasualSpecialExperience={
                        onClickCasualSpecialExperience
                      }
                      onClickCasualCuratedExperience={
                        onClickCasualCuratedExperience
                      }
                      disabled={disabled}
                      backButtonHandler={backButtonHandler}
                      onCasualOfflineExperienceSubmitClick={
                        onCasualOfflineExperienceSubmitClick
                      }
                    />
                  </div>
                )}
              </div>
              <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                <SliderReusableComponent
                  // displayBarButton={true}
                  displayHamburger={true}
                  paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-02.svg")}
                />
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
};

OfflineExperienceManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state?.auth,
  subscription:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  subscriptionData: state?.onboarding?.onboard_subscription_details
    ?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
      ?.multi_service_business_status?.experience_management
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
      ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.experience_management
      : state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.experience_management,
  allSubscriptionsData: state?.onboarding?.onboard_subscription_details
    ?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
      ?.multi_service_business_status
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
      ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
      : state?.onboarding?.onboard_subscription_details?.casual_dining_status,
  scanAndPay: state?.onboarding?.onboard_subscription_details
    ?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
      ?.multi_service_business_status?.scan_and_pay
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
      ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.scan_and_pay
      : state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.scan_and_pay,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(OfflineExperienceManagement));

const InnerComponent = ({
  state,
  onClickCasualSpecialExperience,
  onClickCasualCuratedExperience,
  disabled,
  backButtonHandler,
  onCasualOfflineExperienceSubmitClick,
  enableBooking,
  onClickCopyScan,
}) => {
  return (
    <React.Fragment>
      <TopTextReusableComponent
        headingText="Offline Experience Management"
        headingParagraph={"(Note: Offline Experience are in a physical venue)"}
      />
      <div className="col-12 p-0" style={{ marginTop: "2.5rem" }}>
        <div className="row margin-between-toggler">
          <div className="col-6">
            <div className="f15-700">Booking Enabled</div>
            <p className="f11-400 opacity5">
              Unable this toggle to add bank details for ticket booking
            </p>
            <div
              className="f11-400"
              style={{ color: "#248AFF", cursor: "pointer" }}
              onClick={(e) => enableBooking(true)}
            >
              Setup New Account
            </div>
          </div>
          <div className="col-2 p-0">
            <ToggleButtonWithYesNo
              activeClass={state?.bank_account}
              checkedBox={state?.bank_account}
              onChange={enableBooking}
              editButtons={state?.bank_account}
              disabled={disabled}
              noTitles
            />
          </div>
          {/* <div className="col-4 p-0">
            <div
              className="f11-400"
              style={{ color: "#248AFF", cursor: "pointer" }}
              onClick={(e) => onClickCopyScan()}
            >
              Add Same as Scan & Pay
            </div>
          </div> */}
        </div>
        <div className="f16-700 my-4">Experience Classification</div>
        <div className="row margin-between-toggler">
          <div className="col-6">
            <div className="f15-700">Occasions</div>
          </div>
          <div className="col-6">
            <ToggleButtonWithYesNo
              activeClass={state?.casualDiningSpecialExperience}
              checkedBox={state?.casualDiningSpecialExperience}
              onChange={(e) => onClickCasualSpecialExperience(e)}
              editButtons={state?.casualDiningSpecialExperience}
              disabled={disabled}
              mainStyles={{ justifyContent: "space-evenly" }}
            />
          </div>
          <div className="col-12 mt-4">
            <div className="row">
              <div className="col-6">
                <div className="f15-700">Events</div>
              </div>
              <div className="col-6">
                <ToggleButtonWithYesNo
                  activeClass={state?.casualDiningCuratedExperience}
                  checkedBox={state?.casualDiningCuratedExperience}
                  onChange={(e) => onClickCasualCuratedExperience(e)}
                  editButtons={state?.casualDiningCuratedExperience}
                  disabled={disabled}
                  mainStyles={{ justifyContent: "space-evenly" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="onboarding-map-setup-screen-autodetect-button mt-5 "
        style={{
          position: "fixed",
          bottom: "7rem",
        }}
      >
        <ReusableOnboardingButton
          buttonTitle="Back Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
          buttonText="Back"
          buttonType="button"
          onClick={(e) => backButtonHandler(e)}
        />
        {!disabled && (
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Done"
            buttonType="button"
            onClick={onCasualOfflineExperienceSubmitClick}
            disabled={disabled}
          />
        )}
      </div>
    </React.Fragment>
  );
};
